// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"c196c8f0","453":"150538c9","460":"6f95cb43","468":"42f69b40","755":"1e9668d2","855":"957e5f40","880":"322a604b"}[chunkId] + ".chunk.js";
};